package devxertech.com.pages.dashboard.footerSection

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.FaFacebook
import com.varabyte.kobweb.silk.components.icons.fa.FaLinkedin
import com.varabyte.kobweb.silk.components.icons.fa.FaLocationDot
import com.varabyte.kobweb.silk.components.icons.fa.FaPhone
import com.varabyte.kobweb.silk.components.icons.fa.FaSquareInstagram
import com.varabyte.kobweb.silk.components.icons.fa.FaXTwitter
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.openLinkInNewTab
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A

@Composable
fun HomepageFooter(breakpoint: Breakpoint)  {
    var emailInput by remember { mutableStateOf("") }
    val ctx = rememberPageContext()
    val sitePalette = ColorMode.current.toSitePalette()
    val footerHeaderModifier = Modifier.fontSize(FontSize.Larger)
        .fontFamily(Constants.FONT_FAMILY)
        .color(sitePalette.bodyBackgroundSecondary.rgb).margin(bottom = 30.px)

    val footerTextModifier = Modifier.fontSize(FontSize.Small)
        .fontFamily(Constants.FONT_FAMILY).margin(topBottom = 15.px)
        .whiteSpace(WhiteSpace.PreWrap)
        .color(sitePalette.textFieldBorderColor.rgb)
        .width(if (window.screen.width < 375) 180.px else 300.px)

    Column (modifier = Modifier.fillMaxWidth()
        .backgroundColor(sitePalette.commonSecondaryButtonColor.rgb)) {
        Column(
            modifier = Modifier.fillMaxSize().padding(leftRight = if(window.screen.width in 1550..3000)8.percent else 3 .percent
                , topBottom = 2.percent).display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap)
        ) {
            Row(modifier = Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = if(window.screen.width < 375 ) Arrangement.Start else Arrangement.SpaceEvenly) {
                Column (modifier = Modifier.margin(topBottom = 20.px)){
                    SpanText("About", modifier = footerHeaderModifier)
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier.size(25.px).borderRadius(100.px).border(
                                1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.bodyBackgroundSecondary.rgb
                            ).margin(right = 10.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FaPhone(
                                modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                size = IconSize.XS
                            )
                        }
                        SpanText("+92-305-741-8989", modifier = footerTextModifier)
                    }
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier.size(25.px).borderRadius(100.px).border(
                                1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.bodyBackgroundSecondary.rgb
                            ).margin(right = 10.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FaEnvelope(
                                modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                size = IconSize.XS,
                                style = IconStyle.FILLED
                            )
                        }
                        SpanText("info@devxertech.com", modifier = footerTextModifier)
                    }
                    Row(
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Box(
                            modifier = Modifier.size(25.px).borderRadius(100.px).border(
                                1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.bodyBackgroundSecondary.rgb
                            ).margin(right = 10.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FaLocationDot(
                                modifier = Modifier.color(sitePalette.bodyBackgroundSecondary.rgb),
                                size = IconSize.XS
                            )
                        }

                        SpanText(
                            "101-P, Gulberg II Lahore , Punjab, Pakistan", modifier = footerTextModifier
                        )
                    }
                    Row (modifier = Modifier.margin(top = 20.px)){
                        Box(modifier = Modifier.size(40.px)
                            .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb).borderRadius(100.px).margin(right = 15.px).cursor(
                                Cursor.Pointer).onClick { openLinkInNewTab("https://www.linkedin.com/company/devxertech/") },
                            contentAlignment = Alignment.Center){
                            FaLinkedin(size = IconSize.LG)

                        }
                        Box(modifier = Modifier.size(40.px)
                            .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb).borderRadius(100.px).margin(right = 15.px).cursor(
                                Cursor.Pointer).onClick { openLinkInNewTab("https://www.facebook.com/devxertech") },
                            contentAlignment = Alignment.Center){
                            FaFacebook(size = IconSize.LG, modifier = Modifier.align(Alignment.Center))
                        }
                        Box(modifier = Modifier.size(40.px)
                            .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb).borderRadius(100.px).margin(right = 15.px).cursor(
                                Cursor.Pointer).onClick { openLinkInNewTab("https://www.instagram.com/devxertech/") },
                            contentAlignment = Alignment.Center){
                            FaSquareInstagram(size = IconSize.LG)
                        }
                        Box(modifier = Modifier.size(40.px)
                            .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb).borderRadius(100.px).margin(right = 15.px).cursor(
                                Cursor.Pointer).onClick { openLinkInNewTab("https://twitter.com/devxertech/status/1765689654076899787") },
                            contentAlignment = Alignment.Center){
                            FaXTwitter(size = IconSize.LG)

                        }
                    }
                }
                Column(modifier = Modifier.margin(topBottom = 20.px)) {
                    SpanText("Service", modifier = footerHeaderModifier)
                    FooterNavigationLink(path = "/ui-services", text = "Mobile App UI/UX")
                    FooterNavigationLink(path = "/ui-services", text = "Web App UI/UX")
                    FooterNavigationLink(path = "/mobile-services", text = "IOS App Development")
                    FooterNavigationLink(path = "/mobile-services", text = "Android App Development")
                    FooterNavigationLink(path = "/mobile-services", text = "Cross-Platform App Development")
                    FooterNavigationLink(path = "/web-services", text = "Web Portal Development")
                    SpanText("Version 1.0.0", modifier = Modifier.fontWeight(600)
                        .color(sitePalette.textFieldBorderColor.rgb).fontSize(13.px).opacity(0.4))
                }
                Column (modifier = Modifier.margin(topBottom = 20.px)){
                    SpanText("Support", modifier = footerHeaderModifier)
                    FooterNavigationLink("/career-page", "Careers")
                    FooterNavigationLink("/contact-us", "Contact Us")
                    FooterNavigationLink("/blogs", "Blogs")
                    FooterNavigationLink("/privacy-policy", "Privacy Policy")
                }

//                Column(modifier = Modifier.margin(topBottom = 20.px)) {
//                    SpanText("Subscribe Newsletter", modifier = footerHeaderModifier)
//                    Row {
//                        TextInput(text = emailInput ,
//                            onTextChange = { newValue -> emailInput = newValue},
//                            placeholder = "Email address",
//                            modifier = Modifier.width(330.px).height(55.px).backgroundColor(sitePalette.bodyBackgroundSecondary.rgb).borderRadius(0.px))
//                        Box(modifier = Modifier.width(52.px).height(55.px).backgroundColor(sitePalette.primary.rgb).cursor(
//                            Cursor.Pointer).onClick {  },
//                            contentAlignment = Alignment.Center){
//                            Image(src = Res.Image.send_icon,)
//                        }
//                    }
////                    Box(modifier = Modifier.size(60.px).margin(top = if(breakpoint >= Breakpoint.XL)60.px else 15.px, left = 60.px)
////                        .backgroundColor(sitePalette.primary.rgb).borderRadius(100.px).align(
////                            Alignment.End),
////                        contentAlignment = Alignment.Center){
////                        Image(src = Res.Image.message_icon, modifier = Modifier.size(30.px).onClick { chatBotUI = true  })
////                    }
//                }
            }
        }
    }
}

@Composable
private fun FooterNavigationLink(path: String?, text: String) {
    val sitePalette = ColorMode.current.toSitePalette()
    val textModifier = Modifier
        .fontFamily(Constants.FONT_FAMILY)
        .fontSize(13.px)
        .margin(topBottom = 10.px)
        .color(sitePalette.textFieldBorderColor.rgb)
    if (path == null) {
        SpanText(text, modifier = textModifier)
    } else {
        val ctx = rememberPageContext()
        A(
            attrs = Modifier.attrsModifier { attr("href", path) }
                .styleModifier { property("text-decoration", "none") }
                .onClick { event ->
                    if (event.button.toInt() == 0 && !event.ctrlKey && !event.metaKey &&
                        !event.shiftKey && !event.altKey
                    ) {
                        event.preventDefault()
                        ctx.router.navigateTo(path)
                    }
                }
                .toAttrs()
        ) {
            SpanText(text, modifier = textModifier.cursor(Cursor.Pointer))
        }
    }
}
